<script lang="ts">
  export let title: string = null;
  export let text: string = null;
  export let link: string;
  export let linkText: string;

</script>

<figure class="fizz-card fizz-radius-medium fizz-flex-row-24 fizz-inset-square-24 fizz-bordered">
  <figcaption class="fizz-inset-none">
    <p class="fizz-text-large fizz-stack-8">
      <strong>{title}</strong>
    </p>
    <p class="fizz-stack-16 fizz-text-subdued">
      {text}
    </p>
    <p><a href={link}><strong>{linkText}</strong></a></p>
  </figcaption>
</figure>
